import {
  AuthActions,
  FETCH_USER_EMAIL,
  LOG_OUT,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  UPDATE_USER,
  FETCH_USER_EMAIL_ERROR,
  FETCH_USER_EMAIL_SUCCESS,
  SET_USER_EMAIL,
  SYNC_AUTH_STATE,
} from '../../types/actions/Auth.actions';
import {AuthUser} from '../../types/models/AuthUser';

export interface AuthState {
  user: AuthUser | null;
  isLoading: boolean;
}

const INIT_STATE: AuthState = {
  user: null,
  isLoading: false,
};

export default (state = INIT_STATE, action: AuthActions) => {
  switch (action.type) {
    case UPDATE_USER: {
      return {
        ...state,
        user: action.payload,
      };
    }

    case LOGIN_SUCCESS: {
      return {
        ...state,
        user: {
          ...state.user,
          address: action.payload.address,
          token: action.payload.token,
        },
      };
    }

    case LOGIN_ERROR: {
      return INIT_STATE;
    }

    case LOG_OUT: {
      return INIT_STATE;
    }

    case FETCH_USER_EMAIL:
      return {...state, isLoading: true};

    case FETCH_USER_EMAIL_ERROR:
      return {...state, isLoading: false};

    case SET_USER_EMAIL:
      return {
        ...state,
        user: {
          ...state.user,
          email: action.payload,
        },
      };

    case FETCH_USER_EMAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        user: {
          ...state.user,
          email: action.payload,
        },
      };

    case SYNC_AUTH_STATE: {
      if (action.payload && typeof action.payload === 'object') {
        return {
          ...state,
          ...action.payload,
        };
      }
      return state;
    }

    default:
      return state;
  }
};
